module.exports = __webpack_public_path__ + "static/img/press2.8d80c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press2.png
// module id = BGkg
// module chunks = 0